<template>
  <div
    v-click-outside="() => ui.showCalendar = false"
    :class="type === 'calendar' && 'dr-timepicker--no-hover'"
    class="dr-timepicker"
  >
    <div
      :class="type === 'calendar' && 'dr-timepicker__wrapper--has-calendar'"
      class="dr-timepicker__wrapper"
      @click="ui.showCalendar = !ui.showCalendar"
    >
      <span>
        {{ !date && placeholder ? placeholder : $moment(date).format(this.format) }}
      </span>

      <dr-icon
        v-if="type === 'calendar'"
        :color="'#8E8E92'"
        class="agenda-settings__date-picker--icon"
        name="dashCalendar"
      />
    </div>

    <transition name="fade">
      <div
        v-show="ui.showCalendar"
        class="dr-timepicker__calendar"
      >
        <dr-calendar
          v-model="date"
          @change="ui.showCalendar = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { DrCalendar } from 'cm2tech-vue-calendar'

export default {
  name: 'DrDatepicker',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: [String, Date],
      required: false
    },

    format: {
      type: String,
      required: false,
      default: () => 'DD/MM/YYYY'
    },

    id: {
      type: String,
      required: false,
      default: () => 'drtimepicker_'
    },

    type: {
      type: String,
      required: false,
      default: () => ''
    },

    placeholder: {
      type: String,
      required: false
    }
  },

  components: {
    DrCalendar
  },

  data () {
    return {
      date: null,
      ui: {
        showCalendar: false
      }
    }
  },

  watch: {
    date: {
      deep: false,
      immediate: false,
      handler (v) {
        this.$emit('change', this.date)
      }
    },

    value: {
      deep: false,
      immediate: false,
      handler (v) {
        this.date = this.$moment(this.value).toISOString()
      }
    }
  },

  created () {
    if (this.placeholder) {
      this.$nextTick(() => { this.date = null })
      return
    }
    this.date = this.value
      ? this.$moment(this.value).toISOString()
      : this.$moment().toISOString()
  }
}
</script>
